import { Component, OnInit,Inject,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { Http, Response,Headers } from '@angular/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { NgForm } from '@angular/forms';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-doubtreply',
  templateUrl: './doubtreply.component.html',
  styleUrls: ['./doubtreply.component.css']
})
export class DoubtreplyComponent implements OnInit {

  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }

 dtOptions: DataTables.Settings = {};
  dtElement: DataTableDirective;
  doubts:any=[];
  dtTrigger: Subject<any> = new Subject();
  btn_disable=false;
  btn_class='btn';
  user=this.cookie.get('user_id');
  studentid;
  checkIfTeacher;
  datas;
  user_roleid;
  teacherroles;
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private cookie:CookieService,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,public dialog: MatDialog) {
    activatedRouter.queryParams.subscribe(params => {

      if(params['student'])
        this.studentid = params['student'];
      else
        this.studentid = '';

  });
}

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    this.http.get(this.helper.base_url+'http/get/checkusers',{ headers: this.headers })
    
    .subscribe(data => {
      let body = JSON.parse(data['_body']);
      // this.datas = JSON.parse(data['_body']).users[0];
      // this.user_roleid = JSON.parse(data['_body']).users[0]['role_id'];
      //console.log(this.datas);
      //this.teacherroles = JSON.parse(data['_body']).teacherroles;
      // console.log(this.teacherroles);
      // console.log(this.user_roleid);
      //console.log(this.teacherroles.includes(this.user_roleid));
      //this.checkIfTeacher = this.teacherroles.includes(this.user_roleid);
      this.checkIfTeacher = body.success;
    if(this.checkIfTeacher == false)
    {
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10
      };
  
       this.http.get(this.helper.base_url+'http/get/doubtreply?student_id='+this.studentid,{ headers: this.headers })
        
        .subscribe(data => {
          this.doubts = JSON.parse(data['_body']);
          
            this.dtTrigger.next();
          
         
        });
    }
    else
    {
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10
      };
  
       this.http.get(this.helper.base_url+'http/get/teacherdoubtreply',{ headers: this.headers })
        
        .subscribe(data => {
          this.doubts = JSON.parse(data['_body']);
          
            this.dtTrigger.next();
          
         
        });
    }
    });



  }
}


// WEBPACK FOOTER //
// ./src/app/doubtreply/doubtreply.component.ts